import React, { Component } from "react";
import { ControlLabel, FormControl, FormGroup, InputGroup } from 'react-bootstrap';
import { useIntl } from "react-intl";
import cx from 'classnames';
import withStyles from "isomorphic-style-loader/withStyles";
import ToolTipSection from "../Common/ToolTipSection/ToolTipSection";
import messages from "../../locale/jsonMessages";


import cs from '../../components/commonStyle.css';
import s from './CommonFormComponent.css';

function CommonFormComponent(props) {

    const { input, placeholder, inputClass, meta: { touched, error }, labelText, type, componentClass, isAddon, suffixLabel, prefixLabel, children, maxLength, formGroupClass, toolTipText, tooltipIconClass, tipPlacement, isRequiredInput, note, isNote, addonContainerClass, chars_left } = props;
    const { formatMessage } = useIntl();
    return (
        isAddon ?
            <FormGroup className={cx(cs.noMargin, formGroupClass, addonContainerClass)}>
                {labelText &&
                    <ControlLabel className='commonLabelText'>
                        <span>{labelText}{isRequiredInput && <sup className='isRequiredStar'>*</sup>}</span>
                        {toolTipText && <ToolTipSection label={toolTipText} tooltipIconClass={tooltipIconClass} tipPlacement={tipPlacement} />}
                    </ControlLabel>}
                <InputGroup className={formGroupClass}>
                    {suffixLabel && <InputGroup.Addon className={s.suffix}>{suffixLabel}</InputGroup.Addon>}
                    <FormControl {...input} placeholder={placeholder} type={type} className={cx(inputClass, 'commonInputField')} maxLength={maxLength} />
                    {prefixLabel && <InputGroup.Addon className={s.prefix}>{prefixLabel}</InputGroup.Addon>}
                </InputGroup>
                {touched && error && <span className='errorMessageText'>{formatMessage(error)}</span>}
            </FormGroup>
            :
            children ?
                <FormGroup className={cx(cs.noMargin, formGroupClass)}>
                    {labelText &&
                        <ControlLabel className='commonLabelText'>
                            <span>{labelText}{isRequiredInput && <sup className='isRequiredStar'>*</sup>}</span>
                            {toolTipText && <ToolTipSection label={toolTipText} tooltipIconClass={tooltipIconClass} tipPlacement={tipPlacement} />}
                        </ControlLabel>}
                    <FormControl {...input} placeholder={placeholder}
                        componentClass="select"
                        type={type}
                        className={inputClass}
                        maxLength={maxLength} >
                        {children}
                    </FormControl>
                    {touched && error && <span className='errorMessageText'>{formatMessage(error)}</span>}
                    {note && <div className={s.commonNoteText}>{note}</div>}
                </FormGroup>
                :
                <FormGroup className={cx(cs.noMargin, formGroupClass)}>
                    {labelText &&
                        <ControlLabel className='commonLabelText'>
                            <span>{labelText}{isRequiredInput && <sup className='isRequiredStar'>*</sup>}</span>
                            {toolTipText && <ToolTipSection label={toolTipText} tooltipIconClass={tooltipIconClass} tipPlacement={tipPlacement} />}
                        </ControlLabel>}
                    <FormControl  {...input}
                        placeholder={placeholder}
                        componentClass={componentClass}
                        type={type}
                        className={inputClass}
                        maxLength={maxLength} />
                    {touched && error && <span className='errorMessageText'>{formatMessage(error)}</span>}
                    {chars_left != undefined && chars_left != null && chars_left >= 0 ? <span className='errorMessageText'> {chars_left} {formatMessage(messages.maximumCharacterLeft)}</span> : ''}
                    {isNote && <div className={s.commonNoteText}>{note}</div>}
                </FormGroup>
    )
}

export default withStyles(cs, s)(CommonFormComponent);